import isEqual from "lodash.isequal";
export const areValuesEqual = (value1, value2) => isEqual(value1, value2);
